'use client';

import {
  HomeLandingSections,
  HomeStoriesSection,
  HomeCommunitySection,
  HomeVoicesSection,
  HomeAboutSection,
  CommunityMatrimonyServices,
} from '@/components/homePageSections';

import { useState } from 'react';
import Header from '@/components/Header';
import HomeHeroSection from '@/components/HomeHeroSection';

const communityServices: { label: string; href?: string }[] = [
  { label: "Maratha groom" },
  { label: "Maratha grooms" },
  { label: "Maratha groom in USA" },
  { label: "Maratha groom in Pune" },
  { label: "Maratha groom Profile" },
  { label: "Grooms Maratha from Belgaum" },
  { label: "Maratha var list 96 Kuli" },
  { label: "Maratha Vadhu Var Suchak" },
  { label: "Pune Maratha Vadhu Var Suchak Kendra" },
  { label: "Maratha Vadhu War Suchak Kendra" },
  { label: "Maratha Vadhu Bride Girls Pune" },
  { label: "Maratha Matrimony" },
  { label: "Maratha Marriage" },
  { label: "Maratha Marriage Nashik" },
  { label: "Khandesh Maratha Marriage" },
  { label: "96 Kuli Maratha Marriage" },
  { label: "Maratha Marriage Grooms" },
  { label: "Nashik Maratha Marriage" },
  { label: "Anand Maratha Marriage" },
  { label: "Maratha Marriage grooms Nashik" },
  { label: "Maratha Marriage Divorcee Grooms" },
  { label: "Shinde Maratha Marriage" },
  { label: "Maratha Marriage Grooms List" },
  { label: "VIP Maratha Marriage Bureau" },
  { label: "Maratha Marriage Whatsapp Group Link" },
  { label: "Maratha Marriage bureau" },
  { label: "Khandesh Maratha Marriage Profile list" },
  { label: "Maratha Marriage Jalgaon" },
  { label: "96 Kuli Maratha surname list", href: "/96-kuli-maratha-surname-list" },
  { label: "96 Kuli Maratha list" },
  { label: "96 Kuli Maratha Matrimony" },
  { label: "96 Kuli Maratha surname list pdf" },
  { label: "96 Kuli Maratha Vadhu Var Suchak Mandal Pune" },
  { label: "96k 96 Kuli Maratha images" },
  { label: "96 Kuli Maratha Caste" },
  { label: "96 Kuli Maratha Vadhu Var Whatsapp Group link" },
  { label: "Second Marriage 45 Age 96 Kuli Maratha divorcee brides" },
  { label: "96 Kuli Maratha Brides photos" },
  { label: "96 Kuli Maratha Brides list" },
  { label: "96 Kuli Maratha caste category" },
  { label: "96 Kuli Maratha matrimony login" },
  { label: "96 Kuli Maratha surname list with Gotra" },
  { label: "96 Kuli Maratha Vadhu" },
  { label: "Anand Maratha 96 Kuli Maratha brides" },
  { label: "96K Maratha list" },
  { label: "96K Maratha Surname list" },
  { label: "96k 96 Kuli Maratha images" },
  { label: "96k Maratha matrimony" },
  { label: "Gotra Marathi 96K 96 Kuli Maratha surname list" },
  { label: "96k Maratha surname" },
  { label: "Surname list 96K 96 Kuli Maratha images" },
  { label: "96k Maratha caste" },
  { label: "96k surname list" },
  { label: "96K Maratha surname list Marathi" },
  { label: "Anand Maratha Grooms" },
  { label: "Anand Maratha Grooms Pune" },
  { label: "Anand Maratha Grooms Photos" },
  { label: "96 Kuli Maratha Grooms" },
  { label: "Anand Maratha Grooms Search" },
  { label: "Anand Maratha Grooms Search India" },
  { label: "Anand Maratha Grooms Contact Number" },
  { label: "Goa 96K Maratha Grooms" },
  { label: "Royal Maratha Grooms" },
  { label: "Anand Maratha Grooms Photos Download" },
  { label: "Maratha Grooms in Mumbai" },
  { label: "96 Kuli Maratha Grooms in Mumbai" },
  { label: "96K Maratha Grooms Goa" },
  { label: "Deshmukh Maratha Grooms" },
  { label: "Maratha Grooms in Nashik Govt Services" },
  { label: "Yog Maratha Grooms" },
  { label: "Anand Maratha Grooms Search Free" },
  { label: "Deokar Maratha Grooms" },
  { label: "Great Maratha Grooms" },
  { label: "Deokar Maratha Groom" },
  { label: "Deokar Maratha Groom Photos" },
  { label: "Anand Maratha groom" },
  { label: "96 Kuli Maratha Groom List" },
  { label: "Maratha Groom" },
  { label: "Deokar Maratha Groom Photo" },
  { label: "Jeevanmeet Maratha Groom" },
  { label: "Deokar Maratha Groom Photos Download" },
  { label: "96 Kuli Maratha Groom" },
  { label: "Maratha Groom Family Background" },
  { label: "Reshimgathi Maratha Groom List" },
  { label: "Anand Maratha Groom Search" },
  { label: "Abhijat Maratha Groom" },
  { label: "Anand Vadhu Var Suchak" },
  { label: "Anand Maratha Vadhu Var Pune" },
  { label: "Anand Maratha Vadhu Var Kendra Pune" },
  { label: "Anand Vadhu Var Maratha" },
  { label: "Anand Vadhu Var Suchak Kendra" },
  { label: "Anand Maratha Pune" },
  { label: "Maratha Samaj Suchak Kendra" },
  { label: "Anandmaratha" },
  { label: "Maratha Samaj Vadhu Var Suchak Kendra" },
  { label: "Maratha Vivah Darbar" },
  { label: "Maratha Vadhu Var Magazine" },
  { label: "Maratha Vadhu Magazine" },
  { label: "Maratha Suchak Kendra" },
];

export default function AnandMaratha() {
  const [openFAQ, setOpenFAQ] = useState<number | null>(null);

  return (
    <div className="bg-white">
      {/* Transparent Header */}
      <Header variant="transparent" />

      <HomeHeroSection
        title="96 कुळी मराठा वधू वरांसाठी"
        subtitle="महाराष्ट्रातील अग्रणी विवाहसंस्था"
        trackingSource="anand_maratha"
      />

      <HomeLandingSections />

      <HomeStoriesSection />

      <HomeCommunitySection />

      <HomeVoicesSection />

      <HomeAboutSection />

      {/* FAQ Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
            Frequently Asked Questions
          </h2>
          <div className="max-w-4xl mx-auto">
            <div className="space-y-4">
              {[
                {
                  question: "Which is the best matrimonial site for Maratha Vadhu Var?",
                  answer: "MarathiVadhuVarSuchak.com site is the most trusted for Maratha community Vadhu Var."
                },
                {
                  question: "Which is the free Maratha Matrimony site in Maharashtra?",
                  answer: "MarathiVadhuVarSuchak.com is free for registration. Marathi Vadhu var could sign up for free."
                },
                {
                  question: "How to find Maratha Sthal on Vadhu Var Suchak site?",
                  answer: "First Maratha Vadhu Var has to register free on Marathi Vadhu Var Suchak site and then after profile approval you can search Sthal from the Maratha community."
                },
                {
                  question: "Which is the best way to download the Anand Maratha app?",
                  answer: "Visit MarathiVadhuVarSuchak.com matrimony site to download mobile apps through link provided on site."
                },
                {
                  question: "How to sign up for 96 Kuli Maratha Matrimony search?",
                  answer: "To search 96 Kuli Maratha community brides and grooms first visit MarathiVadhuVarSuchak.com Marathi matrimony site to sign up for free."
                },
                {
                  question: "How to register profile on Maratha Matrimony site?",
                  answer: "MarathiVadhuVarSuchak.com site is the best app for Maratha brides and grooms search. Download the mobile app sign up free."
                },
                {
                  question: "How to search Anand Maratha grooms online?",
                  answer: "Visit Marathi Vadhu Var Suchak site to register first and then after profile approval Maratha brides can search groom profiles online."
                },
                {
                  question: "How to do Anand Maratha bride Search free?",
                  answer: "Visit Marathi Vadhu Var Suchak site to register first. Then after profile approval Maratha grooms can search bride profiles online."
                },
                {
                  question: "How can the Anand Maratha marriage bureau help for marriage?",
                  answer: "To find Vadhu Var from Maratha Samaj you can register free on MarathiVadhuVarSuchak.com a trusted Marathi marriage bureau site."
                },
                {
                  question: "How to get Anand Maratha Brides list online?",
                  answer: "Visit MarathiVadhuVarSuchak.com a trusted Marathi matrimony site to download Maratha Brides list online."
                },
                {
                  question: "How to fill-up Anand Maratha registration form online?",
                  answer: "To fill-up registration form online visit MarathiVadhuVarSuchak.com Marathi matrimony site."
                },
                {
                  question: "How to get Anand Maratha bride search free pdf?",
                  answer: "To get a list of Maratha brides visit MarathiVadhuVarSuchak.com matrimony to sign-up free first."
                },
                {
                  question: "How to search Anand Maratha grooms photos online?",
                  answer: "Marathi Vadhu Var Suchak Marathi matrimony site is free for registration. After profile approval Maratha brides can search Maratha grooms photos online with full profile."
                }
              ].map((faq, index) => (
                <div key={index} className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm">
                  <button
                    onClick={() => setOpenFAQ(openFAQ === index ? null : index)}
                    className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors"
                  >
                    <h3 className="text-lg font-semibold text-gray-900">
                      {faq.question}
                    </h3>
                    <svg
                      className={`w-5 h-5 text-gray-500 transition-transform duration-300 ${
                        openFAQ === index ? 'rotate-180' : ''
                      }`}
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  <div
                    className={`px-6 transition-all duration-300 ease-in-out ${
                      openFAQ === index ? 'pb-4 max-h-96 opacity-100' : 'max-h-0 opacity-0 overflow-hidden'
                    }`}
                  >
                    <div className="text-gray-600 leading-relaxed py-3">
                      <p className="mb-3">{faq.answer}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <CommunityMatrimonyServices
        title="Maratha matrimony for 96 Kuli Maratha"
        items={communityServices}
      />

    </div>
  );
}
